document.addEventListener("DOMContentLoaded", function () {
  var btn = document.getElementById("backToTop");

  if (!btn) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  });

  btn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});


// product crouser 28-jan-26


document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("load", function () {

    if (window.jQuery && $('.product-carousel').length) {

      $('.product-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1 }
          }
        ]
      });

    }

  });
});


